import React, { useMemo } from 'react';
import styled, { ThemeProvider as StyledThemeProvider, } from 'styled-components';
import { spacingLabels, typographyVariantLabels, } from '../../themes';
import { responsiveStyles } from '../../utils/responsiveStyles';
import { cssPostfix } from '../../utils/cssPostfix';
import { themeProviderPropTypes, } from './ThemeProvider.types';
const postfix = (propertyName) => `--${propertyName}-${cssPostfix}`;
const withUnit = (value, unit) => value !== undefined ? value + unit : value;
export const CustomPropertyProvider = styled.div.withConfig({
    shouldForwardProp: (prop) => ['children', 'className'].includes(prop),
})(({ typography, spacing, breakpoints }) => responsiveStyles({
    display: 'contents',
    ...typographyVariantLabels.reduce((rest, variantLabel) => ({
        ...rest,
        [postfix(`typography-${variantLabel}-fontFamily`)]: (breakpointLabel) => { var _a; return (_a = typography[variantLabel][breakpointLabel]) === null || _a === void 0 ? void 0 : _a.fontFamily; },
        [postfix(`typography-${variantLabel}-fontSize`)]: (breakpointLabel) => {
            var _a;
            return withUnit((_a = typography[variantLabel][breakpointLabel]) === null || _a === void 0 ? void 0 : _a.fontSize, 'px');
        },
        [postfix(`typography-${variantLabel}-fontStretch`)]: (breakpointLabel) => {
            var _a;
            return withUnit((_a = typography[variantLabel][breakpointLabel]) === null || _a === void 0 ? void 0 : _a.fontStretch, '%');
        },
        [postfix(`typography-${variantLabel}-lineHeight`)]: (breakpointLabel) => {
            var _a;
            return withUnit((_a = typography[variantLabel][breakpointLabel]) === null || _a === void 0 ? void 0 : _a.lineHeight, 'px');
        },
    }), {}),
    ...spacingLabels.reduce((rest, spacingLabel) => ({
        ...rest,
        [postfix(`space-${spacingLabel}`)]: (breakpointLabel) => withUnit(spacing[spacingLabel][breakpointLabel], 'px'),
    }), {}),
}, breakpoints));
export const ThemeProvider = ({ theme, children, }) => {
    const themeWithVariables = useMemo(() => ({
        ...theme,
        responsive: {
            spacing: spacingLabels.reduce((rest, spacingLabel) => ({
                ...rest,
                [spacingLabel]: postfix(`space-${spacingLabel}`),
            }), {}),
            typography: typographyVariantLabels.reduce((rest, variantLabel) => ({
                ...rest,
                [variantLabel]: {
                    fontFamily: postfix(`typography-${variantLabel}-fontFamily`),
                    fontSize: postfix(`typography-${variantLabel}-fontSize`),
                    fontStretch: postfix(`typography-${variantLabel}-fontStretch`),
                    lineHeight: postfix(`typography-${variantLabel}-lineHeight`),
                },
            }), {}),
        },
    }), [theme]);
    return (React.createElement(CustomPropertyProvider, { ...theme },
        React.createElement(StyledThemeProvider, { theme: themeWithVariables }, children)));
};
ThemeProvider.propTypes = themeProviderPropTypes;
//# sourceMappingURL=ThemeProvider.js.map